__turbopack_context__.v({
  "range": "affiliates-module__mMlzjq__range",
});
